'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function n(t){let e=!1;if(typeof t=="function"&&t.prototype)try{t.arguments&&t.caller;}catch(r){e=!0;}return e}

exports.a = n;
